module.exports = __webpack_public_path__ + "img/20190430.c004ee88.png";